import { render, staticRenderFns } from "./ButtonFile.vue?vue&type=template&id=e2a66cf0&"
import script from "./ButtonFile.vue?vue&type=script&lang=js&"
export * from "./ButtonFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports